import React from 'react';
import { Link } from 'react-router-dom';
import AppStoreButton from '../components/AppStoreButton';
import GooglePlayButton from '../components/GooglePlayButton';
import DiscordButton from '../components/DiscordButton';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Turn Chinese Text into Flashcards Instantly</h1>
          <p className="hero-subtitle">Just paste any Chinese text and get complete flashcards with characters, pinyin, and translations. The fastest way to learn Chinese characters from real-world content.</p>
          <div className="cta-buttons">
            <Link to="/auth" className="cta-button primary">Try It Free</Link>
            <Link to="/about" className="cta-button secondary">Learn More</Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="tutorial-video">
            <video
              controls
              playsInline
              preload="metadata"
              poster="/images/tutorial-poster.jpg"
              className="feature-video"
            >
              <source src="/hanzi_manual.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose Hanzi Flashcards?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
            </div>
            <h3>Instant Card Creation</h3>
            <p>Create up to 50 flashcards at once from any Chinese text. Perfect for learning from articles, messages, or books.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                <path d="M3 3v5h5"></path>
                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>
                <path d="M16 16h5v5"></path>
              </svg>
            </div>
            <h3>Triple-Sided Cards</h3>
            <p>Master characters, pinyin, and translations simultaneously with our unique three-sided approach.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="6"></circle>
                <circle cx="12" cy="12" r="2"></circle>
              </svg>
            </div>
            <h3>Flexible Learning</h3>
            <p>Choose which side appears first to focus on recognition, pronunciation, or translation skills.</p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <h2>Choose Your Plan</h2>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Free Tier</h3>
            <div className="price">$0</div>
            <ul>
              <li>Up to 5 sets</li>
              <li>20 flashcards per set</li>
              <li>Create 20 cards at once from text</li>
              <li>7-day trial of premium features</li>
            </ul>
            <Link to="/auth" className="cta-button">Start Free</Link>
          </div>
          <div className="pricing-card featured">
            <h3>Monthly</h3>
            <div className="price">$4.99<span>/month</span></div>
            <ul>
              <li>Unlimited sets</li>
              <li>Unlimited flashcards</li>
              <li>Create 50 cards at once from text</li>
              <li>All premium features</li>
            </ul>
            <Link to="/auth" className="cta-button">Subscribe</Link>
          </div>
          <div className="pricing-card">
            <h3>Annual</h3>
            <div className="price">$29.99<span>/year</span></div>
            <ul>
              <li>Everything in Monthly plan</li>
              <li>Create 50 cards at once from text</li>
              <li>Priority support</li>
              <li>Save 50%</li>
            </ul>
            <Link to="/auth" className="cta-button">Subscribe</Link>
          </div>
        </div>
      </section>



      {/* Final CTA Section */}
      <section className="final-cta">
        <h2>Start Learning Chinese Smarter</h2>
        <p>Turn any Chinese text into effective flashcards instantly. Join thousands of learners who are mastering Chinese characters faster with Hanzi Flashcards.</p>
        <Link to="/auth" className="cta-button primary">Get Started Now</Link>
      </section>

      <section className="download-section">
        <div className="download-options">
          <div className="download-option">
            <p className="download-text">Download the Mobile App</p>
            <div className="store-buttons">
              <AppStoreButton />
              <GooglePlayButton />
            </div>
          </div>
          <div className="download-option">
            <p className="download-text">Join our community</p>
            <DiscordButton />
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage; 